import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	contactTypes: [],
	addressTypes: [],
	adminTypes: [],
	categoryTypes: [],
	fieldTypes: [],
	bookingTypes: [],
	entityTypes: [],
	maintenanceTypes: [],
	roleList: [],
	userTypes: [],
	credentialTypes: [],
	cardTemplatesTypes: [],
	deviceGroupsTypes: [],
	loadDeviceGroupsTypesComplete: false,
	loadContactTypesComplete: false,
	loadAddressTypesComplete: false,
	loadAdminTypesComplete: false,
	loadCategoryTypesComplete: false,
	loadFieldTypesComplete: false,
	loadBookingTypesComplete: false,
	loadEntityTypesComplete: false,
	loadMaintenanceTypesComplete: false,
	loadRoleListComplete: false,
	loadUserTypesComplete: false,
	loadCredentialTypesComplete: false,
	loadCardTemplatesTypesComplete: false,
	loading: false,
	error: false
};

const typesSlice = createSlice({
	name: 'types',
	initialState,
	reducers: {
		//Load All Types in one go
		loadAllTypes: () => {},

		// Contact Types
		loadContactTypes(state) {
			state.loading = true;
			state.error = null;
		},
		loadContactTypesSuccess(state, action) {
			state.contactTypes = action.payload;
			state.loadContactTypesComplete = true;
			state.loading = false;
		},
		loadContactTypesError(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		// Address Types
		loadAddressTypes(state) {
			state.loading = true;
			state.error = null;
		},
		loadAddressTypesSuccess(state, action) {
			state.addressTypes = action.payload;
			state.loadAddressTypesComplete = true;
			state.loading = false;
		},
		loadAddressTypesError(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		// Admin Types
		loadAdminTypes(state) {
			state.loading = true;
			state.error = null;
		},
		loadAdminTypesSuccess(state, action) {
			state.adminTypes = action.payload;
			state.loadAdminTypesComplete = true;
			state.loading = false;
		},
		loadAdminTypesError(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		// Category Types
		loadCategoryTypes(state) {
			state.loading = true;
			state.error = null;
		},
		loadCategoryTypesSuccess(state, action) {
			state.categoryTypes = action.payload;
			state.loadCategoryTypesComplete = true;
			state.loading = false;
		},
		loadCategoryTypesError(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		// Field Types
		loadFieldTypes(state) {
			state.loading = true;
			state.error = null;
		},
		loadFieldTypesSuccess(state, action) {
			state.fieldTypes = action.payload;
			state.loadFieldTypesComplete = true;
			state.loading = false;
		},
		loadFieldTypesError(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		// Booking Types
		loadBookingTypes(state) {
			state.loading = true;
			state.error = null;
		},
		loadBookingTypesSuccess(state, action) {
			state.bookingTypes = action.payload;
			state.loadBookingTypesComplete = true;
			state.loading = false;
		},
		loadBookingTypesError(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		// Entity Types
		loadEntityTypes(state) {
			state.loading = true;
			state.error = null;
		},
		loadEntityTypesSuccess(state, action) {
			state.entityTypes = action.payload;
			state.loadEntityTypesComplete = true;
			state.loading = false;
		},
		loadEntityTypesError(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		// Maintenance Types
		loadMaintenanceTypes(state) {
			state.loading = true;
			state.error = null;
		},
		loadMaintenanceTypesSuccess(state, action) {
			state.maintenanceTypes = action.payload;
			state.loadMaintenanceTypesComplete = true;
			state.loading = false;
		},
		loadMaintenanceTypesError(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		// Role List
		loadRoleList: (state) => {
			state.loading = true;
			state.error = null;
		},
		loadRoleListSuccess: (state, action) => {
			state.roleList = action.payload;
			state.loadRoleListComplete = true;
			state.loading = false;
		},
		loadRoleListError: (state, action) => {
			state.loading = false;
			state.error = action.payload;
		},
		loadUserTypes(state) {
			state.loading = true;
			state.error = null;
		},
		loadUserTypesSuccess(state, action) {
			state.userTypes = action.payload;
			state.loadUserTypesComplete = true;
			state.loading = false;
		},
		loadUserTypesError(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		loadCredentialTypes(state) {
			state.loading = true;
			state.error = null;
		},
		loadCredentialTypesSuccess(state, action) {
			state.credentialTypes = action.payload;
			state.loadCredentialTypesComplete = true;
			state.loading = false;
		},
		loadCredentialTypesError(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		loadCardTemplatesTypes(state) {
			state.loading = true;
			state.error = null;
		},
		loadCardTemplatesTypesSuccess(state, action) {
			state.cardTemplatesTypes = action.payload;
			state.loadCardTemplatesTypesComplete = true;
			state.loading = false;
		},
		loadCardTemplatesTypesError(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		loadDeviceGroupsTypes(state) {
			state.loading = true;
			state.error = null;
		},
		loadDeviceGroupsTypesSuccess(state, action) {
			state.deviceGroupsTypes = action.payload;
			state.loadDeviceGroupsTypesComplete = true;
			state.loading = false;
		},
		loadDeviceGroupsTypesError(state, action) {
			state.loading = false;
			state.error = action.payload;
		}
	}
});

export const typesActions = typesSlice.actions;

export default typesSlice.reducer;
